export default "__VITE_ASSET__dc494b2f__"